"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ButtonMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../baseComponents/Button"));
var _DropMenu = _interopRequireDefault(require("../baseComponents/DropMenu"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils/utils");
var _index = require("../../index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ButtonMenu = exports.ButtonMenu = function ButtonMenu(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var menuRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (opened) {
      document.addEventListener("mouseup", isTargetDropdown, false);
      var viewPortHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewPortWidth = window.innerWidth || document.documentElement.clientWidth;
      var menu = menuRef.current;
      var menuBounds = menu.getBoundingClientRect();
      var btn = menu.parentElement;
      var btnBound = btn.getBoundingClientRect();
      if (viewPortHeight < menuBounds.top + menuBounds.height) {
        menu.style.bottom = btnBound.height + "px";
      }
      if (!props.forcedPosition) {
        if (viewPortWidth < menuBounds.left + menuBounds.width + 10) {
          btn.classList.add("right");
        }
      }
    } else {
      var _menu = menuRef.current;
      var _btn = _menu.parentElement;
      _menu.style = {};
      _btn.classList.remove("right");
      document.removeEventListener("mouseup", isTargetDropdown, false);
    }
    return function () {
      document.removeEventListener("mouseup", isTargetDropdown, false);
    };
  }, [opened]);
  function handleOpened(e) {
    if (!opened && props.onOpen) {
      props.onOpen(e);
    }
    setOpened(!opened);
  }
  function isTargetDropdown(event) {
    if (!(0, _utils.Contains)(menuRef.current, event.target) && opened) {
      handleOpened();
    }
  }
  function handleOnClick(elClick) {
    if (elClick) {
      elClick();
    }
    handleOpened();
  }
  var isIconOnly = props.withIcon && props.text == null;
  var classes = (0, _classnames["default"])('buttonMenu-component', props.className, props.forcedPosition, {
    'show': opened,
    "showOverSelf": props.showOverSelf,
    'isIconOnly': isIconOnly
  });
  var options = props.options.map(function (el) {
    return _objectSpread(_objectSpread({}, el), {}, {
      onClick: function onClick() {
        return handleOnClick(el.onClick);
      }
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    colorTheme: props.colorTheme,
    size: props.size,
    text: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.text, " ", props.withIcon && /*#__PURE__*/_react["default"].createElement(_index.Icons, {
      name: props.iconName,
      type: "glyph"
    })),
    shapeStyle: props.shapeStyle,
    radius: props.radius,
    disabled: props.disabled,
    onClick: handleOpened,
    icon: props.withIcon,
    iconPosition: isIconOnly ? null : "right",
    noText: isIconOnly
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "menuContainer",
    ref: menuRef
  }, /*#__PURE__*/_react["default"].createElement(_DropMenu["default"], {
    align: props.align,
    values: options
  })));
};
ButtonMenu.Proptypes = {
  //Button props
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  size: _propTypes["default"].oneOf(["xsmall", "small"]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  shapeStyle: _propTypes["default"].oneOf(["fill", "stroke"]),
  radius: _propTypes["default"].oneOf(["round", "square"]),
  disabled: _propTypes["default"].bool,
  //Menu props
  align: _propTypes["default"].oneOf(["left", "middle", "right"]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object,
    value: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    selected: _propTypes["default"].bool,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })),
  onOpen: _propTypes["default"].func,
  //component props
  showOverSelf: _propTypes["default"].bool,
  withIcon: _propTypes["default"].bool,
  iconName: _propTypes["default"].string,
  forcedPosition: _propTypes["default"].oneOf([null, "left", "right"])
};
ButtonMenu.defaultProps = {
  //Button props
  colorTheme: "teal",
  size: "small",
  text: null,
  shapeStyle: "fill",
  radius: "round",
  disabled: false,
  //Menu props
  align: "left",
  options: [],
  //component props
  className: "",
  withIcon: false,
  iconName: "micro-glyph-arrow-head",
  showOverSelf: false,
  forcedPosition: null
};
var _default = exports["default"] = ButtonMenu;